import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import './headerAdmin.css'

import { Layout, Button, Drawer, Modal } from 'antd';
import ChangePassword from '../changePassword/changePassword';
import LeftMenuAdmin from './LeftMenuAdmin';
import RightMenuAdmin from './RightMenuAdmin';
import { MenuOutlined } from '@ant-design/icons';
const { Header } = Layout;

const HeaderAdmin = () => {
    const navigate = useNavigate();

    const [visible, setVisible] = useState(false);
    const [isChangePassModalOpen, setIsChangePassModalOpen] = useState(false);

    let { pathname: location } = useLocation();

    useEffect(() => {
        setVisible(false);
    }, [location]);

    const showDrawer = () => {
        setVisible(!visible);
    };

    const logout = () => {
        localStorage.removeItem('access_token');  // O sessionStorage.removeItem('authToken');
        localStorage.removeItem('refresh_token');  // O sessionStorage.removeItem('authToken');
        navigate('/');
    };

    const openChangePassword = () => {
        setIsChangePassModalOpen(true)
    }

    const handleCancel = () => {
        setIsChangePassModalOpen(false);
    };

    return <Header className='headerAdmin'>
        <div className="navbar-menu">
            <div className="leftMenu">
                {/* <LeftMenuAdmin mode={"horizontal"} /> */}
            </div>
            <Button className="menuButton" type="text" onClick={showDrawer}>
                <MenuOutlined />
            </Button>
            <div className="rightMenu">
                <RightMenuAdmin mode={"horizontal"} logout={logout} openChangePassword={openChangePassword} />
            </div>

            <Drawer
                title={"Afiances"}
                placement="right"
                closable={true}
                onClose={showDrawer}
                open={visible}
                style={{ zIndex: 99999, backgroundColor: '#012E40', color: 'white' }}
            >
                <LeftMenuAdmin mode={"inline"} />
                <RightMenuAdmin mode={"inline"} logout={logout} />
            </Drawer>
        </div>
        {
            isChangePassModalOpen && <>
                <Modal title="Cambiar contraseña" open={isChangePassModalOpen} footer={null} maskClosable={false} onCancel={handleCancel} className='display-center-row align-full-center'>
                    <ChangePassword />
                </Modal>
            </>
        }
    </Header>
}

export default HeaderAdmin;